const en = {
  editAbout: "Edit About ({{lang}})",
  about: "About - {{lang}}",
  files: "Files",
  delete: "Delete",
  downloadFile: "Download File",
  copyImageToClipboard: "Copy file <img> tag to clipboard",
  copyFileToClipboard: "Copy file link to clipboard",
  addNewFile: "Add new file",
  save: "Save",
  cancel: "Cancel",
  all: "All",
// imported from LIComp-UI
  header: {
    title: "OECD Legal Instruments",
    login: "Login",
    logout: "Logout",
    searchPlaceholder: "search...",
    menu: {
      home: "Home",
      generalInformation: "About",
      fullList: "Full list",
      advancedSearch: "Advanced search",
      notPublished: "Create/Publish",
      adherences: "Adherences",
      statistics: "Key figures"
    }
  },
  footer: {
    credits: "© OECD 2017 - OECD Legal Instruments"
  },
  home: {
    searchTitle: "Quick Search",
    searchHint: "Title or reference",
    recentDevelopmentsTitle: "Recent Developments",
    keyFiguresTitle: "Key Figures",
    searchButton: "Search",
    promptSubscription: "Inform me about recent developments",
    subsSuccessMessage: 'You have successfully subscribed to future update notification emails',// "L'abonnement aux futures notifications de mise à jour a été une réussite"
    unsubsSuccessMessage: "You have unsubscribed and will no longer receive update notification emails",
    subsErrorMessage: "An error occured, please try again", //"Une erreur est survenue, veuillez réessayer",
    loginRequired: 'Please login first to use this feature'
  },
  generalInformation: {
    title: "About",
    content: ""
  },

  stats: {
    mainTitle: "Statistics",
    "instruments-by-type": "Legal Instruments by Type",
    "in-force-by-year": "Legal Instruments in Force",
    "non-member-adherences-by-year": "Number of non-Member Adherences to OECD Legal Instruments",
    adherencesByYear: "Adherences by Year",
    "key-partner-adherences": "Adherences of Key Partners",
    "accession-countries-adherences": "Adherences of Accession Countries",
    "country-programmes-adherences": "Adherences of Country-Programme Countries",
    loading: "Loading the graph"
  },
  adherences: {
    title: "List of Adherences",
    loading: "Loading Adherences...",
    adherence: "Adherence",
    oecdMembers: "OECD Members",
    nonMembers: "Non-Members",
    others: 'Other',
    documents: "Documents",
    close: "Close",
    viewOther: "Other adherences",
    resultCount: "Number of adherences:",
  },
  misc: {
    currentLanguage: "English",
    start: "Start",
    end: "End",
    search: "Search",
    date: "Date",
    country: "Adherent",
    status: "Status",
    type: "Type",
    references: "References",
    filter: "Filter",
    clearFilter: "Clear",
    //AdherentMandatory: "* At least one adherent must be selected before starting the search",
    AdherentMandatory:"",
    loading: "Loading...",
    none: 'None',
    downloadInstrumentButton: "Download/Print Booklet",
    downloadInstrumentTooltip: "Download or print the booklet of this legal instrument (PDF file)",
    noResults: "No results...",
    shareLinkButton: "Share Link",
    shareLinkTooltip: "Send a link to this page by email",
    shareSelectionLink: "Share selection link",
    edit: "Edit"
  },
  dates: {
    documentReferences: "Document's references",
    minutesDocReferences: "Summary record references",
    noResults: "No dates for this instrument."
  },
  instruments: {
    normalTitle: " Full list of legal instruments",
    createNewInstrument: "Create new instrument",
    id: "ID",
    instrumentId: "Instrument ID",
    name: "Title",
    status: "Status",
    dateOfPublish: "Date of publish",
    dateOfAdoption: "Date of adoption",
    dateOfInForce: "Date of entry into force",
    dateOfAbrogation: "Date of abrogation",
    dateOfLastAmendment: "Date of last amendment",
    instrument: "Instrument",
    loading: "Loading instruments...",
    resultCount: "Number of legal instruments:",
    reference: "Reference",
    buttons: {
      preview: "Preview",
      open: "Open",
      edit: "Edit"
    }

  },
  instrument: {
    titles: {
      mainText: "Text",
      committees: "Committee(s)",
      dates: "Date(s)/Reference(s)",
      backgroundInformation: "Background information",
      relatedInstruments: "Related instrument(s)",
      supportDocuments: "Related document(s)",
      adherents: "Adherents",
      adoptedOn: "Adopted on",
      lastAmendmentOn: "Last amended on",
      dateOfAbrogation: "Date of abrogation",
      dateOfInForce: "Date of entry into force",
      monitoring: "Implementation",
      legInternalNotes: "LEG internal notes",
      involvedCommittees: "Other Involved Committee(s)",
      parentCommittees: "Parent Committee(s)",
      thereIsErrors: "The instrument could not be saved for those reasons:",
      draftText: "DRAFT",
      publishedReport: 'Published version',
      translations: 'Translations',
      unofficialTranslations: 'Unofficial translations',
      hostedDocuments: 'Hosted documents',
    }
  },
  filters: {
    types: "Type(s)",
    committees: "Committee(s)",
    themes: "Theme(s)",
    status: "Status",
    yearOfAdoption: "Year of adoption",
    yearOfInForce: "Year of entry into force",
    yearOfAbrogation: "Year of abrogation",
    yearOfLastAmendment: "Year of last amendment",
    adherents: "Adherent(s)",
    referenceId: "Reference",
    monitoring: "Monitoring clause",
    monitoringYear: "Year of follow-up report",
    asNeeded: "As needed",
    everyXYears: "Every X years",
    withinXYearsThenAsNeeded: "Within X years then as needed",
    freeTextSearch: "Full-text search",
    freeTextSearchPlaceholder: "Search...",
    searchScope: "Search scope",
    inAllText: "In all text",
    inTitles: "In titles",
    searchType: "Search type",
    exactPhrase: "Exact phrase",
    withAllWords: "With all words",
    publishStatus: "Publish status",
    notPublished: "Not published",
    published: "Published",
    publishDate: "Publish date",
    startDate: "From",
    endDate: "To",
    filter: "Filter",
    dateFilters: "Date",
    searchPlaceholder: "Instrument ID or ONE reference",
    includeNotInForce: "Include legal instruments not in force",
    yearInvalid: "The year must be between 1952 and {max}",
    searchError: 'The search could not be executed',
    activatedTitle: 'Activated filters',
    keywords: 'Keywords'
  },
  printout: {
    title: 'OECD Legal Instruments',
    disclaimer: '<p>This list has been created from the Compendium of OECD Legal Instruments and includes a selection of legal instruments.</p> <p>For access to the official and up-to-date information, including the full text of the selected legal instruments, please consult the Compendium at <a href="https://legalinstruments.oecd.org">https://legalinstruments.oecd.org</a></p>',
    downloadPrintListButton: 'Download/Print List',
    shareListButton: 'Share List',
    printSelection: "Print selection",
    printSelectionWithMainText: "Download selection as a single PDF document",
    printSelectionWithMainTextAndMetaData: "Print selection with main text and meta data",
    printSingleWithMainText: "Print instrument with main text",
    printSingleWithMainTextAndMetaData: "Print instrument with main text and meta data",
    shareListByMailRecipients: 'Email recipients:',
    shareListByMailViaBackendSuccess: 'E-mail message has been sent successfully',
    shareListByMailViaBackendError: 'Oops, something went wrong: {{errorDescription}}',
    validation: {
      noRecipients: 'Missing or invalid recipients',
      emailValidationFailed: 'Failed to validate some of recipient emails.',
      emailsExcluded: 'Emails excluded: {{mails}}',
      emailsIncluded: 'Mail will be sent to: {{mails}}'
    }
  },
  monitoring: {
    clause: "Clause",
    year: "Year",
    documentReferences: "Document reference(s)"
  },
  mainText: {
    loading: "Loading..."
  },
  pdf: {
    page: "Page: ",
    download: "Download"
  },
  relatedInstruments: {
    replacedBy: "Replaced by",
    replaces: "Replaces",
    relatedTo: "Related to"
  },
  error404: {
    title: "404 The page you are looking is not found"
  },

  error403: {
    title: "403 You are not authorized"
  },
  id: 'Id',
  admin: 'Admin',
  addNewLine: 'Add new line',
  englishName: 'English Text',
  frenchName: 'French Text',
  englishSortOrder: 'English Sort Order',
  frenchSortOrder: 'French Sort Order',
  enabled: 'Enabled',
  type: 'Type',
  accessionDate: 'Accession date',
  accessionCountry: 'Acession country',
  keyPartner: 'Key partner',
  hasCountryProgramme: 'Has country programme',
  deleteTitle: 'Delete',
  ok: 'ok',
  adminCancelText: 'If you have made changes, they will not be saved.',
  areYouSure: 'Are you sure?',
  cancelUpdates: 'Cancel Updates',
  adminNoteText: "NOTE: For external lists like countries and committees, please enter an id greater than 100,000 for new entities that must not be synchronized with OECD's source databases. In any case, the synchronization would only affect the names of the list items. Any other properties are not touched during syncronization.",
  aboutSaved: "About Saved",
  listsUpdatedSuccessfully: "Lists updated successfully",
  error: "Error",
  Data: "Data",
  News: "News",
  Publications: "Publications",
  'Job vacancies': "Job vacancies",
  'OECD Legal Instruments': "OECD Legal Instruments",
  'More sites': "More sites",
  'OECD Better Life Index': "OECD Better Life Index",
  'OECD iLibrary': "OECD iLibrary",
  'OECD Observer': "OECD Observer",
  'OECD Insights blog': "OECD Insights blog",
  'OECD Development Centre': "OECD Development Centre",
  'NEA Nuclear Energy Agency': "NEA – Nuclear Energy Agency",
  'IEA International Energy Agency': "IEA – International Energy Agency",
  'SWAC Sahel and West Africa Club': "SWAC – Sahel and West Africa Club",
  'FATF Financial Action Task Force': "FATF - Financial Action Task Force",
  'ITF International Transport Forum': "ITF – International Transport Forum",
  Adherents: "Adherents",
  OECDMember: "OECD Member",
  NonMember: "Non-Member",
  datesReferences: "Date(s)/Reference(s)",
  RelatedInstruments: "Related instrument(s)",
  RelatedDocuments: "Related document(s)",
  backgroundInformation: "Background information",
  instrumentEditPublicViewText: "There is no English public text loaded at the moment. You can upload one by clicking on the upload button or create a new one from scratch by using the edit button.",
  instrumentEditBookletText: "There is no English original document at the moment. You can upload one by clicking on the upload button.",
  relatedDocumentsEditTextP1: "For english documents, enter only an English description, and French version is likewise. In case you have only one language version of a document that you want to be visible to the users on both English and French pages of an instrument, enter both English and French descriptions for it. Introductory text would only be displayed if there is document uploaded, or link provided and a proper description is the given language is entered",
  relatedDocumentsEditTextP2: "If you choose to provide a link (OLISRef or a web link) instead of a file upload, the link would appear on the web page of the instrument but the document would not be included in the brochure",
  "createpublish": "Create/Publish",
  subsSuccessMessage: "You have successfully subscribed to future update notification emails",
  unsubsSuccessMessage: "You have unsubscribed and will no longer receive update notification emails",
  subsErrorMessage: "An error occured, please try again",
  loginRequired: 'Please login first to use this feature',
  instrumentTypes: 'Type(s)',
  committees: 'Committee(s)',
  themes: 'Theme(s)',
  'COUNTRYTERRITORY': 'COUNTRY/TERRITORY',
  'STATUS': 'STATUS',
  'DATE': 'DATE',
  'COMMENTS EN': 'COMMENTS EN',
  'COMMENTS FR': 'COMMENTS FR',
  'DOCUMENTS': 'DOCUMENTS',
  'DELETE': 'DELETE',
  'OECD Members': 'OECD Members',
  'NonMembers': 'Non-Members',
  'add new line': 'add new line',
  'OthersEU': 'Others/EU',
  'URL or ONE Reference': 'URL or ONE Reference',
  'DescriptionEn': 'Description - En',
  'DescriptionFr': 'Description - Fr',
  'Cover Image': 'Cover Image',
  'Photo creditsEn': 'Photo credits - En',
  'Photo creditsFr': 'Photo credits - Fr',
  'coverImageText': 'There is no cover image at the moment. You can upload one by clicking on the edit icon below.',
  'Public View HTML or PDF': 'Public View (HTML or PDF)',
  'Booklet Word or PDF': 'Booklet (Word or PDF)',
  'Edit Public Text': 'Edit Public Text',
  'English introduction': 'English introduction',
  'French introduction': 'French introduction',
  'Add new support document': 'Add new support document',
  'Clear': 'Clear',
  'Filter': 'Filter',
  'Year of adoption': 'Year of adoption',
  'Unpublish': 'Un-publish',
  search: "Search",
  "Share List": "Share List",
  "Email recipients": "Email recipients:",
  emailValidationFailed: 'Failed to validate some of recipient emails.',
  emailsExcluded: 'Emails excluded: {{mails}}',
  emailsIncluded: 'Mail will be sent to: {{mails}}',
  printDisclaimer: '<p>This list has been created from the Compendium of OECD Legal Instruments and includes a selection of legal instruments.</p> <p>For access to the official and up-to-date information, including the full text of the selected legal instruments, please consult the Compendium at <a href="https://legalinstruments.oecd.org">https://legalinstruments.oecd.org</a></p>',
  types: "Type(s)",
  adherenceCheckboxPrimaryText: "Include legal instruments not in force",
  //adherenceCheckboxSecondaryText: "* At least one adherent must be selected before starting the search",
  adherenceCheckboxSecondaryText:"",
  "Booklets deactivated": "Booklets deactivated",
  "English manually uploaded booklet": "English manually uploaded booklet",
  "French manually uploaded booklet": "French manually uploaded booklet",
  "English Territorial Disclaimer": "English Territorial Disclaimer(s)",
  "French Territorial Disclaimer": "English Territorial Disclaimer(s)",
  "Title or reference": "Title or reference",
  "upload": "Upload",
  "Recent Development": "Recent Developments",
  "Inform me about recent developments": "Inform me about recent developments",
  "Quick Search": "Quick Search",
  "from": "From",
  "to": "To",
  "Key Figures": "Key Figures",
  "Number of legal instruments": "Number of legal instruments",
  downloadPrintListButton: 'Download/Print List',
  shareListButton: 'Share List',
  "Fulltext search": "Full-text search",
  "Search scope": "Search scope",
  "In all text": "In all text",
  "In titles": "In titles",
  "Create new instrument": "Create new instrument",
  "Publish status": "Publish status",
  "Home": "Home",
  "About": "About",
  "Advanced search": "Advanced search",
  "Full list": "Full list",
  "Adherences": "Adherences",
  "Key figures": "Key figures",
  "Search": "Search",
  "text": "Text",
  "Background information": "Background information",
  "Related documents": "Related document(s)",
  "Unofficial translations": "Unofficial translations",
  "DateReference": "Date(s)/Reference(s)",
  "Related instruments": "Related instrument(s)",
  "Implementation": "Implementation",
  "LEG internal notes": "LEG internal notes",
  relatedTo: "Related to",
  nonMembers: "Non-Members",
  oecdMembers: "OECD Members",
  disclaimer: "The Compendium of OECD Legal Instruments provides the text of all the legal instruments adopted in the framework of the Organisation for Economic Co-operation and Development (OECD), as well as related information including the list of OECD Members and non-OECD Members having adhered to them (the Adherents).",
  None: "None",
  footerDisclaimer: 'The present Compendium of OECD Legal Instruments is owned by the OECD. It represents significant time and resource investment and shall not be reproduced in whole or significant part without express permission from the OECD. For use, reproduction and translation of individual Legal Instruments, please consult the <a href="https://www.oecd.org/termsandconditions/" target="_blank"> Terms and Conditions.</a>',
  "Recent developments": "Recent Developments",
  status: "Status",
  "DATE OF PUBLISH": "DATE OF PUBLISH",
  "DATE OF ADOPTION": "DATE OF ADOPTION",
  title: 'Title',
  identifier: 'ID',
  reference: "Reference",
  searchPlaceholder: "Instrument ID or ONE reference",
  "Number of adherences": "Number of adherences",
  adhId: "Id",
  "Adherences of Key Partners": "Adherences of Key Partners",
  "Adherences of Accession Countries": "Adherences of Accession Countries",
  "Adherences of Country-Programme Countries": "Adherences of Country-Programme Countries",
  "Legal instruments by type": "Legal instruments by type",
  "Legal Instruments in Force": "Legal Instruments in Force",
  "non-member-adherences-by-year": "Number of non-Member Adherences to OECD Legal Instruments",
  "Not published": "Not published",
  "Published": "Published",
  activatedFilter: "Activated Filter",
  adherenceDate: "Date of adherence",
  "Adopted on": "Adopted on",
  "Amended on": "Amended on",
  activatedTitle: 'Activated filters',
  "Comments for Administrators english": "Comments for Administrators (English)",
  "Comments for Administrators french": "Comments for Administrators (French)",
  "Share via Email": "Share via Email",
};

export default en;
